import { getFile } from 'services/helpers/fetchMethods'

const { fetcher } = require('services/helpers/responseHandler')

const overview = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary', isAllTheTime = false },
  abortController
) =>
  await fetcher.post(
    'performance/overview',
    {
      fromDate: isAllTheTime ? null : fromDate,
      toDate: isAllTheTime ? null : toDate,
      kind,
      isAllTheTime,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode
    },
    abortController
  )

const outreach = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary', isAllTheTime = false },
  abortController
) =>
  await fetcher.post(
    'performance/outreach',
    {
      fromDate: isAllTheTime ? null : fromDate,
      toDate: isAllTheTime ? null : toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind,
      isAllTheTime
    },
    abortController
  )

const OTAOutreach = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary', isAllTheTime = false },
  abortController
) =>
  await fetcher.post(
    'performance/otaoutreach',
    {
      fromDate: isAllTheTime ? null : fromDate,
      toDate: isAllTheTime ? null : toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind,
      isAllTheTime
    },
    abortController
  )

const conversion = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary', isAllTheTime = false },
  abortController
) =>
  await fetcher.post(
    'performance/conversion',
    {
      fromDate: isAllTheTime ? null : fromDate,
      toDate: isAllTheTime ? null : toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind,
      isAllTheTime
    },
    abortController
  )

const reviews = async (
  { fromDate, toDate, parentChainCode, isAllTheTime = false },
  abortController
) =>
  await fetcher.post(
    'performance/reviews',
    {
      fromDate: isAllTheTime ? null : fromDate,
      toDate: isAllTheTime ? null : toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      isAllTheTime
    },
    abortController
  )

const lostSegmentations = async (
  { fromDate, toDate, kind = 'currentSubsidiary' },
  abortController
) =>
  await fetcher.post(
    'performance/lost/segmentations',
    {
      fromDate,
      toDate,
      kind
    },
    abortController
  )

const lostSegmentationsBreakdown = async (
  { fromDate, toDate, segmentRange, kind = 'currentSubsidiary' },
  abortController
) =>
  await fetcher.post(
    'performance/lost/segmentations/breakdown',
    {
      fromDate,
      toDate,
      segmentRange,
      kind
    },
    abortController
  )

const conversionsBreakdown = async (
  {
    fromDate,
    toDate,
    campaign,
    pageSize,
    pageIndex,
    kind,
    onlyDirectBooking,
    parentChainCode
  },
  abortController
) =>
  await fetcher.post(
    'performance/conversion/breakdown-by-campaign',
    {
      fromDate,
      toDate,
      campaign,
      pageSize,
      pageIndex,
      kind,
      onlyDirectBooking,
      parentChainCode
    },
    abortController
  )

const downloadConversionsBreakdownReport = async ({
  campaign,
  onlyDirectBooking,
  parentChainCode,
  toDate,
  fromDate,
  kind
}) => {
  const params = new URLSearchParams()

  if (fromDate) params.append('fromDate', fromDate)
  if (toDate) params.append('toDate', toDate)
  if (campaign) params.append('campaign', campaign)
  params.append('kind', kind)
  if (parentChainCode) params.append('parentChainCode', parentChainCode)
  if (onlyDirectBooking) params.append('onlyDirectBooking', onlyDirectBooking)

  const url = `performance/conversion/breakdown-by-campaign/download?${params.toString()}`

  await getFile(url)
}

const montlyBookings = async ({
  firstYear = null,
  secondYear = null,
  kind,
  parentChainCode = '',
  bookingFilterKind,
  stateCode = '',
  city = '',
  groupId = ''
}) =>
  await fetcher.get('performance/bookings/monthly', {
    firstYear,
    secondYear,
    subsidiaryFilterKind: kind,
    bookingFilterKind,
    parentChainCode: parentChainCode === 'all' ? '' : parentChainCode || '',
    stateCode,
    groupId,
    city
  })

const monthlyOTAConversions = async ({
  year,
  parentChainCode,
  kind,
  city,
  state,
  groupId,
  isOtaOnly
}) =>
  await fetcher.get('performance/ota/conversion', {
    year,
    parentChainCode: parentChainCode === 'all' ? '' : parentChainCode || '',
    subsidiaryFilterKind: kind,
    city,
    state,
    groupId,
    isOtaOnly
  })

const performanceReportsApi = {
  overview,
  outreach,
  OTAOutreach,
  conversion,
  conversionsBreakdown,
  downloadConversionsBreakdownReport,
  reviews,
  montlyBookings,
  monthlyOTAConversions,
  lost: {
    segmentations: {
      breakdown: lostSegmentationsBreakdown,
      overview: lostSegmentations
    }
  }
}

performanceReportsApi.lost.segmentations.breakdown = lostSegmentationsBreakdown

export default performanceReportsApi
